<template>
    <div id="header">
        <div class="content">
            <div class="w1200">
                <div class="tit">
                    <div v-if="vuex_userInfo.nickName">
                        <div class="userInfo" ref="userMenuWrap">
                            <span @click="$router.replace('/home')">欢迎您来到缩水师网</span>
                            <div>
                                <span class="dropDown" :class="{ 'is-open': userMenu === 'user' }"
                                    @click.stop="toggleUserMenu('user')">{{ vuex_userInfo.nickName }}</span>
                                <ul :class="{ 'is-open': userMenu === 'user' }">
                                    <li @click=" $router.push('/personalCenter/userinfo/yhzx?params=0,0')"> 个人中心</li>
                                    <li @click="$router.push('/personalCenter/userinfo/mess?params=0,2')">站内信</li>
                                    <li @click="$router.push('/personalCenter/userinfo/edit?params=0,1')">修改邮箱</li>
                                    <li @click="$router.push('/personalCenter/userinfo/smrz')">实名认证</li>
                                    <li @click="$router.push('/personalCenter/chongzhihetixian/suobichongzhi')">缩币充值({{
                                        vuex_userInfo.userAccount.virtualCoin || 0 }})</li>

                                    <li>
                                        <span @click="$router.push('/login')">登录</span> / <span
                                            @click="$router.push('/login/register')">注册</span>
                                    </li>

                                    <!-- <li @click="$router.push('/login/forgetPassword')"> 忘记密码 </li> -->

                                    <li @click="outLogin">安全退出</li>
                                </ul>
                            </div>
                            <div>
                                <span class="dropDown" :class="{ 'is-open': userMenu === 'publish' }"
                                    @click.stop="toggleUserMenu('publish')">预测/发布</span>
                                <ul :class="{ 'is-open': userMenu === 'publish' }">
                                    <li @click="$router.push('/personalCenter/sss_yc/ssq_sss_yc')">双色球缩水预测</li>
                                    <li @click="$router.push('/personalCenter/sss_yc/dlt_sss_yc')">大乐透缩水预测</li>
                                    <li @click="$router.push('/personalCenter/sss_yc/fcsd_sss_yc')">3d缩水预测</li>
                                    <li @click="$router.push('/personalCenter/sss_yc/pls_sss_yc')">排三缩水预测</li>

                                    <li @click="$router.push('/personalCenter/jqs_fabu/ssq_excel_fabu')">双色球条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/dlt_excel_fabu')">大乐透条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/fcsd_jqs_fabu')">3d条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/pls_excel_fabu')">排三条件发布</li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/xianzhi_excel_fabu')">闲置/定制EXCEL
                                    </li>
                                    <li @click="$router.push('/personalCenter/jqs_fabu/no_room_for_error')">不容错条件试点区
                                    </li>
                                </ul>
                            </div>

                            <div class="msg">
                                <svg t="1745331974792" class="icon" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="2598" width="16" height="16">
                                    <path
                                        d="M510.5152 23.7568a488.1408 488.1408 0 1 0 0 976.2304 488.1408 488.1408 0 0 0 0-976.2304z m0 796.16a58.5728 58.5728 0 1 1 58.5728-58.624c0 32.3584-26.1632 58.624-58.5216 58.624z m58.5728-225.6384c0 24.32-26.1632 43.9296-58.5728 43.9296-32.3584 0-58.5728-19.5584-58.5728-43.9296V242.8928c0-24.2688 26.2144-43.8784 58.5728-43.8784 32.3584 0 58.5728 19.6096 58.5728 43.8784v351.3856z"
                                        fill="#d81e06" p-id="2599"></path>
                                </svg>
                                <!-- 滚动视口：PC 端普通文本，移动端为顶部通栏滚动条 -->
                                <div class="msg-viewport">
                                    <div class="msg-track">
                                        <div class="msg-text">{{ declareText }}</div>
                                        <!-- 第二份仅移动端滚动时用（首尾相接实现无缝循环），PC 端隐藏 -->
                                        <div class="msg-text">{{ declareText }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <!-- <span @click="$router.replace('/home')">logo</span> -->
                        <div>
                            <span>欢迎您来到缩水师网</span>
                            <span class="btn login" @click="$router.push('/login')">登录</span>
                            <span class="btn register" @click="$router.push('/login/register')">注册</span>
                        </div>
                    </div>

                    <div class="siteMap">
                        <div class="lottery-nav" :class="{ 'is-open': navOpen }">
                            <div class="nav-trigger" @click="toggleNav">
                                彩票导航
                                <i class="el-icon-arrow-down nav-arrow" :class="{ 'is-open': navOpen }"></i>
                            </div>
                            <div class="nav-panel">
                                <div class="nav-group">
                                    <div class="tit blue">指标考核</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/ssddt',1);">缩水大厅</span>
                                        <span @click="openInNewTab('/ssdgw',2);">缩水单冠王</span>
                                        <span @click="openInNewTab('/sdssxb',3);">十大学霸</span>
                                        <span @click="openInNewTab('/hxwysz',4);">海选万元实战单</span>
                                    </div>
                                </div>
                                <div class="nav-group">
                                    <div class="tit magenta">跳蚤市场</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/excel',4);">EXCEL技巧师大厅</span>
                                        <span @click="openInNewTab('/suoshuiruanjian',5)">缩水软件特区</span>
                                    </div>
                                </div>
                                <div class="nav-group">
                                    <div class="tit green">帮扶中心</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/sttzzbfzx',6);">投注站申请帮扶</span>
                                        <span @click="openInNewTab('/sttzzbfzx',6);">实战超市</span>
                                        <span @click="openInNewTab('/sttzzbfzx',6);">众筹招股大厅</span>
                                        <span @click="openInNewTab('/sttzzbfzx',6);">彩票代表海选</span>
                                    </div>
                                </div>
                                <div class="nav-group">
                                    <div class="tit orange">申请入住</div>
                                    <div class="cont sky">
                                        <span @click="openInNewTab('/personalCenter/hangjiaguanli/apply_sss',null)">缩水师申请</span>
                                        <span @click="openInNewTab('/personalCenter/tzz_bf/cp_tzz_sq_bf',null);">彩票投注站申请</span>
                                        <span @click="openInNewTab('','')">技巧师申请</span>
                                        <span @click="openInNewTab('','')">软件交易师申请</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <!-- <span>在线客服</span> -->
                        <!-- <a href="tencent://message/?uin=1173679416&Site=JooIT.com&Menu=yes">
							<img src="@/assets/login/qq.png" alt=""/>
						</a> -->
                        <!-- <a href="tencent://message/?uin=970611994&Site=JooIT.com&Menu=yes">
							<img src="@/assets/login/qq.png" alt=""/>
						</a> -->
                        <img @click="artificial" src="@/assets/login/qq.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
        <hxlMenu />
    </div>
</template>

<script>
import hxlMenu from "./menu.vue";

export default {
    name: "app-header",
    components: {
        hxlMenu,
    },
    data() {
        return {
            userInfo: {},
            // 顶部声明文案（滚动条内容，PC/移动端共用一份）
            declareText: "缩水网声明:本站仅可购买缩水数据、缩水条件、缩水软件、众筹招股、不能购彩!",
            // 移动端「彩票导航」展开状态（PC 端仍为悬浮展开）
            navOpen: false,
            // 移动端头部下拉菜单展开项：null | 'user' | 'publish'（PC 端仍为悬浮展开）
            userMenu: null,
        };
    },
    mounted() {
        // 点击菜单区域之外时收起下拉（移动端点击展开时生效）
        document.addEventListener('click', this.closeUserMenu);
        // setTimeout(_=>{
        // 	this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
        // },1200)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeUserMenu);
    },
    methods: {
        // 移动端点击展开/收起头部下拉菜单（桌面端仍为悬浮展开，不受影响）
        toggleUserMenu(name) {
            if (!window.matchMedia('(max-width: 1200px)').matches) {
                return;
            }
            this.userMenu = this.userMenu === name ? null : name;
        },
        // 点击头部下拉菜单之外时收起
        closeUserMenu(e) {
            if (!this.userMenu) {
                return;
            }
            const wrap = this.$refs.userMenuWrap;
            if (wrap && !wrap.contains(e.target)) {
                this.userMenu = null;
            }
        },
        // 移动端点击「彩票导航」展开/收起导航内容
        toggleNav() {
            this.navOpen = !this.navOpen;
        },
        // 新标签页打开站内路由（与首页保持一致）
        openInNewTab(path, menuActiveIndex = null) {
            if (menuActiveIndex === "") {
                return;
            }
            this.$vuex("vuex_menuActiveIndex", menuActiveIndex);
            const env = process.env.NODE_ENV;
            let obj = {
                development: "http://localhost:8080", // 本地开发地址
                production: process.env.VUE_APP_BASE_API, // 线上地址
            };
            const fullUrl = `${obj[env]}#${path}`;
            window.open(fullUrl, "_blank");
        },
        // 联系客服
        artificial() {
            // this.copyClipboard('1173679416')
            this.copyClipboard('168650441')
        },
        // 剪切板
        copyClipboard(data) {
            let url = data;
            let oInput = document.createElement("input");
            oInput.value = url;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            this.$notify({
                title: "成功",
                message: "qq号已复制到剪切板，请在腾讯QQ中搜索添加",
                type: "success",
                offset: 100,
            });
            oInput.remove();
        },
        outLogin() {
            localStorage.clear();
            this.$router.replace("/login");
        },
    },
};
</script>

<style lang="scss" scoped>
/* 彩票导航板块（移入 header 的 siteMap，全站公共显示；样式参考设计规范：彩色分组标题 + 横向链接网格） */
.siteMap {
    flex: 1;
    min-width: 0;
}

/* 彩票导航：默认仅显示「彩票导航」4字，悬浮触发下方分组面板 */
.lottery-nav {
    position: relative;
    display: inline-block;

    .nav-trigger {
        background: #d43c33;
        color: #fff;
        font-size: 15px;
        padding: 6px 14px;
        cursor: pointer;
        border-radius: 3px;
        white-space: nowrap;
        user-select: none;

        // 展开标识箭头：仅移动端显示（PC 端是悬浮展开，不需要）
        .nav-arrow {
            display: none;
            margin-left: 6px;
            transition: transform 0.25s;

            &.is-open {
                transform: rotate(180deg);
            }
        }
    }

    .nav-panel {
        display: none;
        position: absolute;
        top: 100%;
        left: 50%;
        box-sizing: border-box;
        transform: translateX(-86%);
        width: 1200px;
        margin-top: 0;
        background: #fff;
        border: 1px solid rgba(0, 0, 0, 0.2);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 999;
        padding: 14px 16px 16px;
        text-align: center;
        grid-template-columns: repeat(4, 1fr);

        .nav-group {
            display: inline-block;
            vertical-align: top;
            padding: 0 18px;
            border-left: 1px solid rgba(0, 0, 0, 0.1);

            &:first-child {
                border-left: none;
                padding-left: 0;
            }

            .tit {
                font-size: 18px;
                font-weight: bold;
                padding-bottom: 8px;

                &.blue { color: #3d7edb; }
                &.magenta { color: #d63384; }
                &.green { color: #2e9e5b; }
                &.orange { color: #e67817; }
            }

            .cont {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                column-gap: 20px;
                row-gap: 4px;

                span {
                    padding: 2px 0;
                    font-size: 14px;
                    cursor: pointer;
                    width: max-content;
                    position: relative;
                    color: #3072cd;

                    &:hover {
                        color: #d43c33;
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    &:hover .nav-panel {
        display: grid;
    }
}

.dropDown {
    display: block;
    position: relative;

    &::before {
        content: "";
        display: block;
        position: absolute;
        top: 24px;
        right: 4px;
        width: 6px;
        height: 6px;
        border-bottom: 2px solid #999;
        border-right: 2px solid #999;
        transform: translateY(-50%) rotate(48deg);
    }

    // 展开时小箭头朝上（移动端点击展开时生效）
    &.is-open::before {
        transform: translateY(-50%) rotate(228deg);
    }
}


#header {
    .content {
        background-color: #f0f3f7;
    }

    .tit {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        >div {
            display: flex;
            align-items: center;

            >span {
                display: inline-block;
                padding: 15px 30px;
            }

            >div {
                &.userInfo {
                    display: flex;
                    align-items: center;
                    position: relative;

                    >span {
                        padding-left: 0;
                    }

                    >div {
                        span {
                            padding: 15px;
                            position: relative;
                            z-index: 10;
                            border: 1px solid transparent;
                            cursor: pointer;
                        }

                        &:hover>span {
                            background-color: #ffffff;
                            border: 1px solid rgba(0, 0, 0, 0.2);
                            border-bottom: 0;
                        }

                        &:hover ul {
                            display: block;
                        }
                    }

                    ul {
                        position: absolute;
                        top: 50px;
                        z-index: 9;
                        min-width: 150px;
                        display: none;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        text-align: center;
                        background-color: #ffffff;
                        list-style: none;
                        padding: 0;
                        margin: 0;
                        width: 200px;

                        li {
                            padding: 10px 20px;
                            cursor: pointer;

                            &:hover {
                                background-color: rgba(0, 0, 0, 0.1);
                            }

                            span {
                                padding: 0;
                            }
                        }
                    }

                    .msg {
                        border-bottom: 1px solid #4b8bb8;
                        color: #ff0000;
                        padding: 5px 10px;
                        margin-left: 20px;
                        display: flex;
                        align-items: center;

                        svg {
                            margin-right: 5px;
                        }

                        .msg-viewport {
                            min-width: 0;
                        }

                        .msg-track {
                            display: inline-block;

                            .msg-text {
                                display: inline-block;

                                // PC 端只显示一份文案（第二份仅供移动端滚动拼接使用）
                                &+.msg-text {
                                    display: none;
                                }
                            }
                        }
                    }
                }

                span {
                    display: inline-block;

                    &.btn {
                        margin-right: 10px;
                        border-radius: 5px;
                        cursor: pointer;

                        &.login {
                            background-color: #faaa25;
                            color: #ffffff;
                            font-weight: bold;
                        }

                        &.register {
                            border: 1px solid rgba(0, 0, 0, 0.2);
                        }
                    }
                }
            }
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效，与 .w1200 容器自适应保持一致） ===== */
@media (max-width: 1200px) {
    #header {
        .tit {
            flex-wrap: wrap;
            row-gap: 6px;
            // 顶部留白去掉，让通栏滚动条紧贴头部最上方
            padding: 0 0 8px;

            > div {
                flex-wrap: wrap;
                width: 100%;

                > span {
                    padding: 6px 12px;
                    font-size: 13px;
                }
            }
        }

        /* 移动端无 hover：点击「彩票导航」展开/收起导航内容 */
        .lottery-nav {
            display: block;
            width: 100%;

            .nav-trigger {
                display: block;
                width: 100%;
                box-sizing: border-box;
                text-align: center;

                // 展开标识箭头：移动端显示，展开时旋转 180 度
                .nav-arrow {
                    display: inline-block;
                }
            }

            .nav-panel {
                display: none; // 默认收起，点击「彩票导航」后展开
                position: static; // 参与文档流，显示在按钮下方而非悬浮遮挡
                top: auto;
                left: auto;
                width: 100%;
                max-width: 100%;
                margin-top: 0;
                transform: none;
                grid-template-columns: 1fr; // 窄屏：四个分组纵向排列
                text-align: left;

                .nav-group {
                    padding: 0 10px;
                    border-left: none;
                    border-top: 1px solid rgba(0, 0, 0, 0.1);

                    &:first-child {
                        border-top: none;
                    }

                    .tit {
                        font-size: 16px;
                        padding: 8px 0 4px;
                    }

                    .cont {
                        grid-template-columns: repeat(2, 1fr);
                        column-gap: 10px;
                        row-gap: 2px;

                        span {
                            font-size: 13px;
                            width: auto; // 覆盖基础样式的 max-content，窄屏允许换行
                        }
                    }
                }
            }

            // 展开状态：显示导航内容
            &.is-open .nav-panel {
                display: grid;
            }
        }

        .siteMap {
            width: 100%;
            flex: none; // 基础样式的 flex:1 会让 flex-basis 变成 0，窄屏换行时被挤成 0 宽
            order: 3;
        }

        /* 声明改为顶部通栏滚动条（仅移动端）
           注意：下面的嵌套结构必须与基础样式 .tit > div > div.userInfo 保持一致，
           否则选择器优先级低于基础样式，移动端的覆盖不生效 */
        .tit {
            > div {
                > div {
                    &.userInfo {
                        width: 100%;
                        flex-wrap: wrap;

                        /* 移动端无 hover：下拉菜单改为点击展开，
                           定位到各自触发按钮正下方，不受 .userInfo 顶部偏移影响 */
                        >div {
                            position: relative;

                            >span {
                                border-radius: 3px 3px 0 0;

                                &.is-open {
                                    background-color: #ffffff;
                                    border-color: rgba(0, 0, 0, 0.2);
                                }
                            }

                            ul {
                                top: 100%;
                                left: 0;
                                right: auto;
                                width: auto;
                                min-width: 160px;
                                text-align: left;
                                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

                                li {
                                    padding: 10px 16px;
                                }

                                /* 点击展开状态 */
                                &.is-open {
                                    display: block;
                                }
                            }
                        }

                        .msg {
                            order: -1; // 置顶到头部第一行
                            flex: none;
                            width: 100%;
                            margin-left: 0; // 移动端不要左边距
                            padding: 6px 0;
                            border-bottom: 0; // 底线交给 ::before 铺满整屏宽度
                            position: relative;

                            // 满宽底线：用绝对定位铺满整个视口宽度（.w1200 移动端左右各 12px 内边距）
                            &::before {
                                content: "";
                                position: absolute;
                                left: 50%;
                                bottom: 0;
                                width: 100vw;
                                transform: translateX(-50%);
                                border-bottom: 1px solid #4b8bb8;
                                pointer-events: none;
                            }

                            .msg-viewport {
                                flex: 1;
                                min-width: 0;
                                overflow: hidden;
                            }

                            .msg-track {
                                display: inline-block;
                                white-space: nowrap;
                                // 末尾留白，与两份文案之间的间距一致，保证 -50% 位移后首尾无缝衔接
                                padding-right: 24px;
                                animation: msgScroll 20s linear infinite;

                                .msg-text {
                                    display: inline-block;

                                    &+.msg-text {
                                        display: inline-block;
                                        margin-left: 24px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/* 通栏滚动：轨道内含两份文案，整体左移 50%（正好一份文案宽度）实现无缝循环 */
@keyframes msgScroll {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(-50%);
    }
}
</style>
